import React, { useState, useEffect, useCallback } from 'react';
import RiwayatDetailModal from '../components/RiwayatDetailModal';
import Pagination from '../components/Pagination';
import api from '../api/axiosConfig';
import { FaEye } from 'react-icons/fa';
import { showErrorAlert } from '../utils/alert';
import './ServicePage.css';

const RiwayatServisPage = () => {
  const [kendaraanList, setKendaraanList] = useState([]);
  const [isDetailOpen, setDetailOpen] = useState(false);
  const [selectedKendaraan, setSelectedKendaraan] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const API_URL = '/api/kendaraan';

  const fetchData = useCallback(async (page = 1, limit = itemsPerPage, keyword = debouncedSearchTerm) => {
    try {
      const response = await api.get(`${API_URL}?keyword=${keyword}&page=${page}&limit=${limit}`);
      setKendaraanList(response.data.data);
      setTotalItems(response.data.totalItems);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.currentPage);
    } catch (error) {
      console.error("Gagal mengambil data kendaraan:", error);
      showErrorAlert("Gagal memuat data kendaraan.");
    }
  }, [itemsPerPage, debouncedSearchTerm]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(timerId);
  }, [searchTerm]);

  useEffect(() => {
    fetchData(currentPage, itemsPerPage, debouncedSearchTerm);
  }, [debouncedSearchTerm, currentPage, itemsPerPage, fetchData]);

  const handlePageChange = (pageNumber) => {
    fetchData(pageNumber);
  };

  const handleItemsPerPageChange = (limit) => {
    setItemsPerPage(limit);
    fetchData(1, limit);
  };

  const openDetailModal = (kendaraan) => {
    setSelectedKendaraan(kendaraan);
    setDetailOpen(true);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <p>Manage Service / Riwayat Service</p>
        <h1>Ringkasan Riwayat Service per Kendaraan</h1>
      </div>

      <div className="content-card">
        <div className="toolbar">
          <input 
            type="text"
            placeholder="Cari Nomor Kendaraan, Jenis..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginLeft: 'auto', width: '300px' }} // Lebarkan sedikit
          />
        </div>
        
        <div className="table-responsive-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Nomor Kendaraan</th>
                <th>Jenis Kendaraan</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {kendaraanList.map((kendaraan, index) => (
                <tr key={kendaraan._id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{kendaraan.nomorKendaraan}</td>
                  <td>{kendaraan.jenis}</td>
                  <td className="action-buttons">
                    <button onClick={() => openDetailModal(kendaraan)} title="Lihat & Kelola Riwayat"><FaEye /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      
      </div>

      <RiwayatDetailModal 
        show={isDetailOpen} 
        onClose={() => setDetailOpen(false)} 
        kendaraan={selectedKendaraan} 
      />
    </div>
  );
};

export default RiwayatServisPage;